module.exports = __webpack_public_path__ + "static/media/sgd-3.77973a82.png";